import * as api from '../../resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchActivityEventsDictionaryRequest = () => ({
  type: actionTypes.FETCH_ACTIVITY_EVENTS_DICTIONARY_REQUEST,
});

export const fetchActivityEventsDictionarySuccess = (activityEvents) => ({
  type: actionTypes.FETCH_ACTIVITY_EVENTS_DICTIONARY_SUCCESS,
  activityEvents,
});

export const fetchActivityEventsDictionaryFailure = () => ({
  type: actionTypes.FETCH_ACTIVITY_EVENTS_DICTIONARY_FAILURE,
});

export const fetchActivityEventsDictionary = () => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;

    dispatch(fetchActivityEventsDictionaryRequest());
    const activityEvents = await api.fetchActivityEventsDictionary(locale);
    dispatch(fetchActivityEventsDictionarySuccess(activityEvents));
  } catch (error) {
    console.error('ACTIVITY_EVENTS_DICTIONARY', error);
    dispatch(fetchActivityEventsDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/activity-events-dictionary.actions.js